import React from 'react';

const benefitsData = [
  {
    category: 'Marketing',
    benefits: [
      { name: 'Access to Anacle’s Image Bank', auth: true, pref: true },
      { name: 'Marketing Materials', auth: true, pref: true },
      { name: 'Customisable Presentations', auth: false, pref: true },
      { name: 'Co-marketing Programs', auth: false, pref: true },
      { name: 'Customized Webinars', auth: false, pref: true },
      { name: 'Preferred Press Release', auth: false, pref: true },
    ],
  },
  {
    category: 'Sales Tools',
    benefits: [
      { name: 'Dedicated Channel Partner Manager', auth: false, pref: true },
      {
        name: 'Sales Leads through Preferred Partner Locator',
        auth: false,
        pref: true,
      },
    ],
  },
  {
    category: 'Training & Support',
    benefits: [
      { name: 'Standard Webinars', auth: true, pref: true },
      { name: 'On-Demand Webinars', auth: false, pref: true },
      { name: 'Access to Premium Support', auth: true, pref: true },
    ],
  },
  {
    category: 'Partner Community',
    benefits: [{ name: 'Channel Newsletter', auth: true, pref: true }],
  },
  {
    category: 'Rebate Program',
    benefits: [{ name: 'Semi Annual Rebate Program', auth: false, pref: true }],
  },
];

export default function ProgramBenefits() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 mb-10">
      <div className="col-span-1"></div>
      <div className="col-span-4 mx-auto py-14 bg-white">
        <h1 className="text-2xl lg:text-4xl mb-4">Program Benefits</h1>
        <p className="text-sm mt-8 mb-8 lg:w-3/5">
          As an Anacle VAR, you will enjoy a series of benefits ranging from
          access to Anacle’s image bank to field technical support. The table
          below shows the breakdown of benefits for the different partners.
        </p>
        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr className="text-left text-[#BF984D] text-sm border-b border-gray-700">
                <th className="w-1/2 py-2"></th>
                <th className="w-1/4 text-center py-2">Authorised VARs</th>
                <th className="w-1/4 text-center py-2">
                  Preferred / Exclusive VARs
                </th>
              </tr>
            </thead>
            <tbody>
              {benefitsData.map((section, i) => (
                <React.Fragment key={i}>
                  <tr>
                    <td
                      colSpan={3}
                      className="text-lg text-[#BF984D] font-medium py-4"
                    >
                      {section.category}
                    </td>
                  </tr>
                  {section.benefits.map((b, j) => (
                    <tr key={j} className="border-b border-gray-300 text-sm">
                      <td className="py-2 pt-6">{b.name}</td>
                      <td className="py-2 pt-6 text-center">
                        {b.auth ? 'Yes' : 'No'}
                      </td>
                      <td className="py-2 pt-6 text-center">
                        {b.pref ? 'Yes' : 'No'}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
